import React from 'react'
import { Translator } from '@morningtrain/react-translations'
import { PageHeader } from 'ui/layouts'
import TranslatedTitle from 'widgets/TranslatedTitle'
import Card from 'ui/cards/Card'
import { Model, ValueToCollection } from '@morningtrain/react-resources'
import TableHeader from 'ui/table/TableHeader'
import * as Filters from 'support/filters'
import { Table } from 'widgets/crud'
import CardGroup from 'ui/layouts/CardGroup'
import HistoricShiftRow from 'pages/app/shifts/HistoricShiftRow'
import EntriesHighlight from 'pages/app/shifts/partials/EntriesHighlight'
import AdminPage from 'pages/app/AdminPage'
import EntriesFilters from './entries/EntriesFilters'

export default function Entries (props) {
  return (
    <AdminPage>
      <Translator namespace='historicshifts'>

        <PageHeader title={<TranslatedTitle name='title' />} />
        <CardGroup>
          <Model resourceName='shifts.historic' operationName='index_with_summary'>
            <EntriesHighlight />
            <Card>
              <ValueToCollection name='collection'>
                <TableHeader>
                  <EntriesFilters />
                </TableHeader>
                <Table className='cursor-pointer'>
                  <HistoricShiftRow />
                </Table>
              </ValueToCollection>
              <Filters.PaginationFilter />
            </Card>
          </Model>
        </CardGroup>
      </Translator>
    </AdminPage>
  )
}
